import useMediaQuery from "./useMediaQuery";

const MOBILE_MD_QUERY = "(max-width: 767px)";

export function useIsMobileMd() {
  return useMediaQuery(MOBILE_MD_QUERY);
}
